



















import { Vue, Component } from 'vue-property-decorator'
import { AppModule } from '../store/modules/app'
import { AppMain, Navbar, Sidebar, NavTitle } from './components'

@Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    NavTitle
  }
})
export default class extends Vue {
  get title() {
    return this.$route.meta.title ? this.$route.meta.title : '页面标题'
  }

  get showTitle() {
    // 展示 showTitle 属性为 true 的路由
    return this.$route.meta.showTitle
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation
    }
  }
}
